import React from 'react'
import LoginMethodFrame from '../shared/LoginMethodFrame'
import PasskeyIcon from '../icons/PasskeyIcon'
import { preventDefault } from '../../helpers'
import { InjectedAuthProps, withAuthProps } from '../../context/withAuthProps'
import { AuthMethodEnum, eventHandler } from '../../types.d'
import { useRetryMethod } from '../../hooks/useAuthActions'

type PureSigninPasskeyRetryProps = {
  onContinue: eventHandler
} & InjectedAuthProps

export const PureSigninPasskeyRetry = ({
  onContinue,
  error,
  ...props
}: PureSigninPasskeyRetryProps) => (
  <LoginMethodFrame
    title="Sign in with passkey"
    recoveryPrompt="Don't have your passkey?"
    recaptchaSiteKey={null}
    error={error}
    {...props}
  >
    <div>
      <div className="flex items-center justify-center">
        <PasskeyIcon />
      </div>
      <p className="text-center mt-3">
        Use your passkey to confirm it's really you
      </p>
    </div>
    <button
      onClick={preventDefault(onContinue)}
      type="submit"
      tabIndex={1}
      className="w-full text-white bg-slate-600 hover:bg-slate-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
    >
      {error ? 'Try Again' : 'Continue'}
    </button>
  </LoginMethodFrame>
)

const BoundSigninPasskeyRetry = withAuthProps(PureSigninPasskeyRetry)

export const SigninPasskeyRetry = () => {
  const retryMethod = useRetryMethod()

  return <BoundSigninPasskeyRetry onContinue={retryMethod} />
}

export default SigninPasskeyRetry
